import axiosInstance from "../config/API";

const API_ENDPOINT = "/plan.php";

// Fetch all plans
export const fetchPlansApi = async (searchText = "") => {
  const payload = {
    search_text: searchText,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch plans:", response.data.body.plan);
  return response.data.body.plan || [];
};

// Add a new plan
export const addPlanApi = async (planData) => {
  const payload = {
    plan_name: planData.plan_name,
    plan_prize: planData.plan_price,
    current_user_id: planData.current_user_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("add plan:", response.data);
  return response.data;
};

// Update a plan
export const updatePlanApi = async (planData) => {
  const payload = {
    plan_name: planData.plan_name,
    plan_prize: planData.plan_price,
    current_user_id: planData.current_user_id,
    edit_plan_id: planData.plan_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("update plan:", response.data);
  return response.data;
};

// Delete a plan
export const deletePlanApi = async (planId, currentUserId) => {
  const payload = {
    delete_plan_id: planId,
    current_user_id: currentUserId,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("delete plan:", response.data);
  return response.data;
};
